export type CreateRateLimiterOptions = {
  itemsPerMinute: number;
  maxItems: number;
};

const WINDOW_MS = 60_000;

export const createRateLimiter = (options: CreateRateLimiterOptions) => {
  let timestamps: number[] = [];
  let totalSent = 0;

  return <T>(event: T): T | null => {
    if (totalSent >= options.maxItems) {
      return null;
    }

    const now = Date.now();
    const cutoff = now - WINDOW_MS;
    timestamps = timestamps.filter((entry) => entry >= cutoff);

    if (timestamps.length >= options.itemsPerMinute) {
      return null;
    }

    timestamps.push(now);
    totalSent += 1;
    return event;
  };
};
